interface GradientCartIconProps {
  size?: number;
  className?: string;
}

const GradientCartIcon: React.FC<GradientCartIconProps> = ({ size = 18, className = '' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 18 18"
      fill="none"
      className={className}
      role="img"
      aria-label="Gradient Cart Icon"
    >
      <g filter="url(#filter0_iii_6323_9939)">
        <path
          d="M8.41926 14.0217C8.41926 14.562 7.96898 15 7.41354 15C6.85809 15 6.40781 14.562 6.40781 14.0217C6.40781 13.4815 6.85809 13.0435 7.41354 13.0435C7.96898 13.0435 8.41926 13.4815 8.41926 14.0217Z"
          fill="url(#paint0_linear_6323_9939)"
        />
        <path
          d="M12.7774 15C13.3328 15 13.7831 14.562 13.7831 14.0217C13.7831 13.4815 13.3328 13.0435 12.7774 13.0435C12.2219 13.0435 11.7717 13.4815 11.7717 14.0217C11.7717 14.562 12.2219 15 12.7774 15Z"
          fill="url(#paint1_linear_6323_9939)"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M2.85343 3C2.52017 3 2.25 3.26277 2.25 3.58693C2.25 3.9111 2.52017 4.17389 2.85343 4.17389H4.64055C4.67295 4.17389 4.70072 4.19506 4.70652 4.22607L5.84728 10.6564C5.95741 11.2456 6.48498 11.6739 7.10065 11.6739H13.9164C14.2496 11.6739 14.5198 11.4111 14.5198 11.0869C14.5198 10.7628 14.2496 10.5 13.9164 10.5H7.10065C7.06824 10.5 7.04048 10.4774 7.03468 10.4464L6.95936 9.71738H14.0116C14.6404 9.71738 15.1751 9.27187 15.2707 8.66738L15.7349 5.73259C15.8536 4.98198 15.2566 4.30433 14.4758 4.30433H5.94754L5.89391 3.69131C5.78378 3.10211 5.25621 3 4.64055 3H2.85343Z"
          fill="url(#paint2_linear_6323_9939)"
        />
      </g>
      <defs>
        <filter
          id="filter0_iii_6323_9939"
          x="1.44203"
          y="3"
          width="16.9627"
          height="14"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="0.577124" />
          <feGaussianBlur stdDeviation="0.577124" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.45 0" />
          <feBlend mode="normal" in2="shape" result="effect1_innerShadow_6323_9939" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="3" dy="2" />
          <feGaussianBlur stdDeviation="1.32739" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.125797 0 0 0 0 0.104989 0 0 0 0 0.478797 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_innerShadow_6323_9939"
            result="effect2_innerShadow_6323_9939"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="-0.807974" dy="0.23085" />
          <feGaussianBlur stdDeviation="0.461699" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0" />
          <feBlend
            mode="normal"
            in2="effect2_innerShadow_6323_9939"
            result="effect3_innerShadow_6323_9939"
          />
        </filter>
        <linearGradient
          id="paint0_linear_6323_9939"
          x1="2.25"
          y1="3.28662"
          x2="14.0269"
          y2="16.8949"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#15CCCB" />
          <stop offset="0.492409" stopColor="#4987FF" />
          <stop offset="1" stopColor="#8B1CFA" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_6323_9939"
          x1="2.25"
          y1="3.28662"
          x2="14.0269"
          y2="16.8949"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#15CCCB" />
          <stop offset="0.492409" stopColor="#4987FF" />
          <stop offset="1" stopColor="#8B1CFA" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_6323_9939"
          x1="2.25"
          y1="3.28662"
          x2="14.0269"
          y2="16.8949"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#15CCCB" />
          <stop offset="0.492409" stopColor="#4987FF" />
          <stop offset="1" stopColor="#8B1CFA" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default GradientCartIcon;